import { api, TOKEN_KEY, DEMO_TOKEN_KEY } from "@/lib/api";

/** The private demo — the code travels with the browser tab so a viewer can hop between portals. */
const KEY = "cx_demo_code";

export const demoCode = () => sessionStorage.getItem(KEY) || localStorage.getItem(KEY) || "";
export const rememberDemoCode = (k) => { sessionStorage.setItem(KEY, k); localStorage.setItem(KEY, k); };

const isDemoToken = (t) => {
  try { return !!JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))).demo; }
  catch { return false; }
};

/** The demo sits in this tab; it only borrows the browser-wide slot when no real sign-in holds it. */
export function storeDemoToken(token) {
  sessionStorage.setItem(DEMO_TOKEN_KEY, token);
  const held = localStorage.getItem(TOKEN_KEY);
  if (!held || isDemoToken(held)) localStorage.setItem(TOKEN_KEY, token);
}

export function clearDemoToken() {
  sessionStorage.removeItem(DEMO_TOKEN_KEY);
  if (isDemoToken(localStorage.getItem(TOKEN_KEY) || "")) localStorage.removeItem(TOKEN_KEY);
}

/** Open one demo portal: a fresh sandbox session, then a full page load so nothing stale carries over. */
export async function openDemo(code, portal) {
  const { data } = await api.post("/demo/session", { key: code, portal });
  rememberDemoCode(code);
  storeDemoToken(data.token);
  window.location.assign(data.home);
}

export const demoLink = (origin, code, portal) => `${origin}/demo${portal ? `/${portal}` : ""}?k=${encodeURIComponent(code)}`;
